import { getListQuarterTariffApi, upsertQuarterTariffApi, deleteQuarterTariffApi } from 'helpers/backend_helper';
import { takeEvery, put, call } from 'redux-saga/effects';
import { 
    getListQuarterTariffFail, 
    getListQuarterTariffSuccess,
    upsertQuarterTariffSuccess,
    upsertQuarterTariffFail,
    deleteQuarterTariffSuccess,
    deleteQuarterTariffFail,
    getListQuarterTariff
} from './actions';
import { 
    GET_LIST_QUARTERTARIFF,
    UPSERT_QUARTERTARIFF,
    DELETE_QUARTERTARIFF
} from './actionTypes';


function* onGetListQuarterTariff() {
    try {
        const result = yield call(getListQuarterTariffApi)
        yield put(getListQuarterTariffSuccess(result))
    } catch (error) {
        yield put(getListQuarterTariffFail(error?.message || error))
    }
}

function* onUpsertQuarterTariff({ payload }) {
    try {
        const result = yield call(upsertQuarterTariffApi, payload)
        yield put(upsertQuarterTariffSuccess(result))
        // Refresh the list after successful upsert
        yield put(getListQuarterTariff())
    } catch (error) {
        yield put(upsertQuarterTariffFail(error?.message || error))
    }
}

function* onDeleteQuarterTariff({ payload }) {
    try {
        yield call(deleteQuarterTariffApi, payload)
        yield put(deleteQuarterTariffSuccess(payload))
    } catch (error) {
        yield put(deleteQuarterTariffFail(error?.message || error))
    }
}

function* saga() {
    yield takeEvery(GET_LIST_QUARTERTARIFF, onGetListQuarterTariff)
    yield takeEvery(UPSERT_QUARTERTARIFF, onUpsertQuarterTariff)
    yield takeEvery(DELETE_QUARTERTARIFF, onDeleteQuarterTariff)
}

export default saga;